(function () {
  if (window.__stoqNotifyMeLoaded) return;
  window.__stoqNotifyMeLoaded = true;

  // Set on sold-out buy buttons by product-form-block.liquid. The variant picker
  // does not always move it onto the button after a variant change, so the
  // selected variant's availability is checked as well.
  var NOTIFY_CLASS = 'notify-me-trigger';

  function getSelectedVariantId(btn) {
    var formComponent = btn.closest('product-form');
    var input = formComponent && formComponent.querySelector('[data-product-form-variant]');
    var id = input && input.value ? Number(input.value) : null;
    return id || (window._RestockRocketConfig && window._RestockRocketConfig.selected_variant_id) || null;
  }

  function selectedVariantIsSoldOut(btn) {
    var product = window._RestockRocketConfig && window._RestockRocketConfig.product;
    var id = getSelectedVariantId(btn);
    if (!product || !product.variants || !id) return false;
    for (var i = 0; i < product.variants.length; i++) {
      if (Number(product.variants[i].id) === id) return product.variants[i].available === false;
    }
    return false;
  }

  // STOQ's config only describes the page's own product, so buttons for other
  // products (featured product blocks and the like) are left alone.
  function isPageProduct(btn) {
    var product = window._RestockRocketConfig && window._RestockRocketConfig.product;
    return !!(product && btn.id && btn.id.indexOf('-' + product.id + '-') !== -1);
  }

  function getNotifyButton(target) {
    var btn = target && target.closest ? target.closest('product-form button[name="add"]') : null;
    if (!btn || !isPageProduct(btn)) return null;
    return btn.classList.contains(NOTIFY_CLASS) || selectedVariantIsSoldOut(btn) ? btn : null;
  }

  function openStoqForm(btn) {
    var stoq = window._RestockRocket;
    var config = window._RestockRocketConfig;
    if (!stoq || typeof stoq.openModal !== 'function' || !config || !config.product) return;
    stoq.openModal(config.product, getSelectedVariantId(btn));
  }

  // Capture phase on document runs before UpCart's own listener on the button,
  // so stopping here keeps a sold-out variant from ever reaching /cart/add.
  document.addEventListener(
    'click',
    function (e) {
      var btn = getNotifyButton(e.target);
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      btn.type = 'button';
      openStoqForm(btn);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      var submitter = e.submitter || (form && form.querySelector ? form.querySelector('button[name="add"]') : null);
      if (!getNotifyButton(submitter)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
    },
    true
  );
})();
